module.exports = __webpack_public_path__ + "img/checkedSet.96de4bdb.png";